import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionType} from '../../constants';

@Component({
    selector: 'app-question-family-list',
    templateUrl: './question-family-list.component.html',
    styleUrls: ['./question-family-list.component.scss'],
    standalone: false
})
export class QuestionFamilyListComponent implements OnInit {

  @Input() question: Question;
  @Input() showRemove = true;
  @Output() questionAnswer = new EventEmitter<any>();

  questions: Question[] = [];
  enteredItems: any[] = [];
  questionType = QuestionType;
  isSavingData = false;

  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    if (this.question) {
      this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
        .subscribe(questions => {
          for (const q of questions) {
            this.questions.push(Object.assign({}, q));
          }

          this.enteredItems = [];
          this.questionService.getLists(this.question?.cent_aq_question_id)
            .subscribe(items => {
              if (items?.length) {
                this.enteredItems = [];
                for (const item of items) {
                  const details = item?.details.split('|');
                  if (details?.length) {
                    this.enteredItems.push({
                      Name: details[1],
                      Surname: details[2],
                      Relationship: details[0],
                      DateOfBirth: details[4],
                      FuneralCoverAmount: details[3],
                      Premium: 0,
                      questions: this.questions
                    });
                  }
                }
                if (this.enteredItems?.length) {
                  for (const item of this.enteredItems) {
                    item.questions.forEach(q => {
                      if (q.cent_aq_question_id === 713) {
                        q.answer = item.Name;
                      } else if (q.cent_aq_question_id === 714) {
                        q.answer = item.Surname;
                      } else if (q.cent_aq_question_id === 715) {
                        q.answer = item.DateOfBirth;
                      } else if (q.cent_aq_question_id === 716) {
                        q.answer = item.Relationship;
                      } else if (q.cent_aq_question_id === 717) {
                        q.answer = item.FuneralCoverAmount;
                      }
                    });
                  }
                  setTimeout(() => {
                    this.saveValue();
                  }, 500);
                }
              } else {
                this.enteredItems.push({
                  Name: '',
                  Surname: '',
                  Relationship: '',
                  DateOfBirth: '',
                  FuneralCoverAmount: 0,
                  Premium: 0,
                  questions: this.questions
                });
              }
            });
        });
    }
  }

  addAnother(): void {
    if (this.enteredItems.every(item => item.Name && item.Surname && item.Relationship && item.DateOfBirth && item.FuneralCoverAmount)) {
      this.enteredItems.push({
        Name: '',
        Surname: '',
        Relationship: '',
        DateOfBirth: '',
        FuneralCoverAmount: 0,
        Premium: 0,
        questions: this.questions
      });
    }
  }

  joinString(name: string, surname: string): string {
    return name + ' ' + surname;
  }

  selectChange(value: Question, questionIndex: number, enteredItemsIndex: number): void {
    this.enteredItems[enteredItemsIndex].questions[questionIndex].answer = value?.answer;
    if (this.enteredItems[enteredItemsIndex].questions[questionIndex].cent_aq_question_id === 716) {
      this.enteredItems[enteredItemsIndex].Relationship = this.enteredItems[enteredItemsIndex].questions[questionIndex].answer;
    }
    this.saveValue();
  }

  onInputChange(value: any, questionIndex: number, enteredItemsIndex: number): void {
    this.enteredItems[enteredItemsIndex].questions[questionIndex] = value;
    if (this.enteredItems[enteredItemsIndex].questions[questionIndex].cent_aq_question_id === 713) {
      this.enteredItems[enteredItemsIndex].Name = this.enteredItems[enteredItemsIndex].questions[questionIndex].answer;
    }
    if (this.enteredItems[enteredItemsIndex].questions[questionIndex].cent_aq_question_id === 714) {
      this.enteredItems[enteredItemsIndex].Surname = this.enteredItems[enteredItemsIndex].questions[questionIndex].answer;
    }
    if (this.enteredItems[enteredItemsIndex].questions[questionIndex].cent_aq_question_id === 715) {
      this.enteredItems[enteredItemsIndex].DateOfBirth = this.enteredItems[enteredItemsIndex].questions[questionIndex].answer;
    }
    if (this.enteredItems[enteredItemsIndex].questions[questionIndex].cent_aq_question_id === 717) {
      this.enteredItems[enteredItemsIndex].FuneralCoverAmount = this.enteredItems[enteredItemsIndex].questions[questionIndex].answer;
    }
    this.saveValue();
  }

  saveValue(): void {
    setTimeout(() => {
      const isValid = this.enteredItems.every(item => item.Name && item.Surname && item.Relationship && item.DateOfBirth && item.FuneralCoverAmount);
      if (this.question && isValid && !this.isSavingData) {
        this.isSavingData = true;
        for (let i = 0; i < this.enteredItems.length; i++) {
            let value = '';
            value += this.enteredItems[i].Relationship + '|';
            value += this.enteredItems[i].Name + '|';
            value += this.enteredItems[i].Surname + '|';
            value += this.enteredItems[i].FuneralCoverAmount + '|';
            value += this.enteredItems[i].DateOfBirth;
            this.getPremium(i, value);
        }
      }
    }, 1000);
  }

  getPremium(index: any, answer: any): void {
    this.question.answer = answer;
    this.enteredItems[index].Premium = '...';
    this.questionService.saveIndividualAnswer(this.question, (+this.question.item_id + index))
      .subscribe(x => {
        if (x) {
          this.questionService.getPremium(this.question.product_class_id, (+this.question.item_id + index), this.question?.product_id)
            .subscribe(r => {
              if (r?.length) {
                this.enteredItems[index].Premium = r[0]?.premium;
              }
              this.questionAnswer.emit(this.question);
              this.isSavingData = false;
            });
        }
      });
  }

  removeItem(index: any): void {
    this.questionService.removeRiskListItem(this.question.product_class_id, this.question.item_id + index)
      .subscribe(r => {
        this.enteredItems.splice(index, 1);
      });
  }
}
